export const TypingIndicator = () => (
  <div className="flex justify-start">
    <div className="py-1 flex items-center gap-3 text-slate-500 dark:text-slate-400">
      <span className="text-sm text-slate-500 dark:text-slate-400 font-medium">Thinking</span>
      <div className="flex items-center gap-1.5 pt-2">
        <span className="w-1.5 h-1.5 rounded-full bg-slate-400 dark:bg-slate-500" style={{ animation: 'typingDot 1.4s ease-in-out infinite', animationDelay: '0ms' }}></span>
        <span className="w-1.5 h-1.5 rounded-full bg-slate-400 dark:bg-slate-500" style={{ animation: 'typingDot 1.4s ease-in-out infinite', animationDelay: '200ms' }}></span>
        <span className="w-1.5 h-1.5 rounded-full bg-slate-400 dark:bg-slate-500" style={{ animation: 'typingDot 1.4s ease-in-out infinite', animationDelay: '400ms' }}></span>
      </div>
    </div>
    <style>{`
      @keyframes typingDot {
        0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
        30%            { transform: translateY(-5px); opacity: 1; }
      }
    `}</style>
  </div>
);
